import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { Locale } from 'src/environments/language.config';
import { getLocalizedUrl } from 'src/helpers/language-map';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private translateService = inject(TranslateService);
  private router = inject(Router);

  public async changeLanguage(language: string): Promise<void> {
    await firstValueFrom(this.translateService.use(language));

    this.syncUrlWithLanguage(language);
  }

  public syncUrlWithCurrentLanguage(): void {
    this.syncUrlWithLanguage(this.translateService.getCurrentLang() ?? Locale.DE);
  }

  private syncUrlWithLanguage(language: string): void {
    const newUrl = getLocalizedUrl(language, this.router.url);

    if (newUrl !== this.router.url) {
      this.router.navigateByUrl(newUrl, { replaceUrl: true });
    }
  }
}
